'use strict';

/**
 * Unique script identifier.
 *
 * @export
 */
export type ScriptId = string;
